import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { BodyContainer, Header, HeaderBtn, HeaderTitle } from "../bank/styles";
import Loader from "../../components/components/Loader";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DataTable from "react-data-table-component";
import AddProperty from "./Add";
import Repo from "../../Repository/Repo";
import { Toast } from "../../components/components/Toast";
import SearchField from "../../components/components/Search";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InfoIcon from "@mui/icons-material/Info";
import ViewImages from "./ViewImages";
import useGetProperties from "./useGetProperties";
import DeleteDialog from "../../components/reusableComponents/DeleteDialog";

function Property() {
  const [searchText, setSearchText] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [remModal, setRemModal] = useState(false);

  const { loading, records, onRem, onGet, onUpdate, onAdd } =
    useGetProperties();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const columns = [
    // {
    //   name: "#",
    //   selector: (row, i) => {
    //     if (currentPage == 1) {
    //       return i + 1;
    //     } else {
    //       return (currentPage - 1).toString() + (i + 1);
    //     }
    //   },
    // },
    {
      name: "ID#",
      selector: (row) => row?.id,
    },

    {
      width: "300px",
      name: "Seller Name",
      selector: (row) => row?.sellerName,
    },
    {
      width: "300px",
      name: "Purchaser Name",
      selector: (row) => row?.purchaserName,
    },
    {
      width: "200px",
      name: "Detail Registry",
      selector: (row) => row?.detailRegistry,
    },
    {
      name: "Attached Pics",
      cell: (row) => {
        if (row?.pics.length > 0) {
          return (
            <Button
              size="small"
              variant="contained"
              onClick={() => handleEdit(row, "images")}
              sx={{ fontSize: "9px" }}
            >{`view pics`}</Button>
          );
        } else {
          return "No pics";
        }
      },
    },
    {
      name: "Document #",
      selector: (row) => row?.documentNo,
    },
    {
      name: "Mutation #",
      selector: (row) => row?.mutationNo,
    },
    {
      name: "Total",
      selector: (row) => row?.totalAmount,
    },
    {
      name: "Received",
      selector: (row) => row?.received,
    },
    {
      name: "Balance",
      selector: (row) => row?.balance,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <Stack direction="row" alignItems="center" spacing="8px">
            {/* <InfoIcon
              sx={{ color: "#4eaf51" }}
              /> */}
            {/* <BorderColorIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row, "edit")}
              // onClick={() => handleEdit(row)}
            /> */}
            <DeleteForeverIcon
              sx={{ color: "#D35353" }}
              onClick={() => handleEdit(row, "remove")}
            />
          </Stack>
        );
      },
    },
  ];
  const toggle = () => {
    setAddModal((prev) => !prev);
    if (addModal) {
      setSelectedRow(null);
    }
  };
  const viewToggle = () => {
    setViewModal((prev) => !prev);
    if (viewModal) {
      setSelectedRow(null);
    }
  };

  const remToggle = () => {
    setRemModal((prev) => !prev);
  };

  const handleEdit = (row, type = null) => {
    setSelectedRow(row);
    if (type == "remove") {
      remToggle();
    } else if (type == "edit") {
      toggle();
    } else if (type == "images") {
      viewToggle();
    } else {
      toggle();
    }
  };

  const onSuccess = (e) => {
    toggle();
    onAdd(e);
  };

  const handleInput = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };

  const handleUpdate = (e) => {
    toggle();
    onUpdate(e);
  };

  const subHeaderComponentMemo = () => {
    return (
      <Box>
        <SearchField
          text="search details..."
          name="searchText"
          sx={{ background: "#fff !important", borderRadius: "8px" }}
          value={searchText}
          onChange={handleInput}
        />
      </Box>
    );
  };

  const handleRow = (row) => {
    handleEdit(row, "edit");
  };

  const handleDelete = async () => {
    remToggle();
    onRem(selectedRow._id);
    try {
      let { data } = await Repo.property({
        request: {
          method: "deletePropertyAgreement",
          data: {
            _id: selectedRow._id,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        Toast("success", "Deleted Successfully");
      } else {
        Toast("error", data.response.status.statusMessage);
        onGet();
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const filtered = useMemo(() => {
    if (searchText) {
      return records.filter((i) => {
        if (i.documentNo || i.sellerName) {
          return (
            i?.documentNo
              .toString()
              .toLowerCase()
              .startsWith(searchText.toLowerCase()) ||
            i?.sellerName
              .toString()
              .toLowerCase()
              .startsWith(searchText.toLowerCase())
          );
        }
      });
    } else {
      return records;
    }
  }, [records, searchText]);

  return (
    <Box>
      <Header>
        <HeaderTitle>Property Details</HeaderTitle>
        <HeaderBtn variant="contained" onClick={toggle}>
          Add Details
          <AddCircleOutlineIcon sx={{ ml: "8px", color: "#4eaf51" }} />
        </HeaderBtn>
      </Header>
      <BodyContainer>
        {!loading && (
          <DataTable
            columns={columns}
            data={filtered}
            highlightOnHover={true}
            pointerOnHover={true}
            pagination
            subHeader
            subHeaderComponent={subHeaderComponentMemo()}
            onChangePage={handlePageChange}
            Clicked
            onRowClicked={(row) => handleRow(row)}
          />
        )}
        {loading && <Loader loading={true} />}
      </BodyContainer>

      {addModal && (
        <AddProperty
          onClose={toggle}
          onSuccess={onSuccess}
          onUpdate={handleUpdate}
          row={selectedRow}
        />
      )}
      {viewModal && <ViewImages onClose={viewToggle} row={selectedRow} />}

      <DeleteDialog
        open={remModal}
        onClose={remToggle}
        onClickYes={handleDelete}
      />
    </Box>
  );
}

export default Property;
